import { IDataset } from '@metservicedev/platforms-services-interface/src/services/movIntegrationMDS/MovIntegrationMDSModel';
import { Modal } from 'antd';
import React, { useMemo } from 'react';

import { useDatasetById } from '../../utils/hooks/useDatasetById';
import LoadingSpinner from '../../components/LoadingSpinner';

interface DatasetDetailModalProps {
    close(): void;
    datasetId?: string;
}
export const DatasetDetailModal = ({ close, datasetId }: DatasetDetailModalProps) => {
    const [dataset, isLoading, error] = useDatasetById({ datasetId });

    const datasetDetailsForUser = useMemo(() => {
        if (!dataset) {
            return null;
        }
        return Object.keys(dataset).reduce<Partial<IDataset>>((prev, datasetProperty) => {
            if (['private_attributes', 'capability_time_interpolations'].includes(datasetProperty) || datasetProperty.startsWith('_')) {
                return prev;
            } else {
                return {
                    ...prev,
                    [datasetProperty]: dataset[datasetProperty],
                };
            }
        }, {});
    }, [dataset]);

    return (
        <Modal title='Dataset info' width={800} visible={!!datasetId} onOk={close} onCancel={close}>
            {isLoading && <LoadingSpinner />}
            {error && error}
            {datasetDetailsForUser && <pre style={{ overflowX: 'scroll' }}>{JSON.stringify(datasetDetailsForUser, null, 2)}</pre>}
        </Modal>
    );
};
